export default "__VITE_ASSET__Cy0xmDGJ__"